{
  "languages": {
    "en": "English",
    "it": "Italiano"
  },
  "labels": {
    "measures": "Measures",
    "kpis": "KPIs",
    "cancel": "Cancel",
    "update": "Update",
    "continue": "Continue",
    "confirm": "Confirm",
    "clear-all": "Clear all",
    "title-allowed": "Allowed Values",
    "title-target": "Target Value",
    "value": "Value",
    "unit-measure": "Unit of Measure",
    "required": "Mandatory field",
    "selected": "Selected",
    "delete-all": "Delete all",
    "delete": "Delete",
    "empty": "",
    "kpitype-quantitative": "Quantitative",
    "kpitype-qualitative": "Qualitative",
    "search": "Search",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "description": "Description",
    "save": "Save",
    "close": "Close",
    "back": "Back",
    "title-unit-measure": "Unit of Measure"
  },
  "strings": {
    "select-location": "Set KPI position",
    "reset-location": "Clear KPI position",
    "select-location-info": "Select or write the coordinates of the location linked to this Kpi",
    "arrow-button-hint": "Click the arrow to the right of each resource to select it",
    "selected-items-hint": "Resources for later calculations",
    "kpi-description": "Description of the KPI",
    "no-selected-items": "No resources selected",
    "no-kpis-items": "No KPIs available",
    "no-measures-items": "No measures available",
    "target-hint": "Defines the ideal target value for the KPI",
    "allowed-hint": "Defines the allowed values for the qualitative KPI",
    "allowed-info": "First position means greater weight for the KPI, Last position less weight",
    "confirm-title": "Confirm",
    "placeholder": "Enter item",
    "confirm-message": "Are you sure you want to remove the item '{name}'?",
    "kpi-type-title": "Type of values",
    "kpi-type-hint": "Select values type for the manual KPI",
    "invalid-value": "Please enter a valid value",
    "duplicate": "Item already present in the list",
    "max-reached": "Maximum number of items reached ({count})",
    "added-success": "Item added successfully",
    "removed-success": "Item '{name}' removed",
    "kpi-type": "KPI Type",
    "title-kpi-values": "KPI Values",
    "values-definition-hint": "Add values for manual KPI calculation",
    "values-type-change-confirm": "If you change the values type, all entered values and, if applicable, the list of allowed values, will be deleted.",
    "add-value": "Add value",
    "number-hint": "Enter a numeric value",
    "cleared-all": "All items cleared",
    "values-clear-all-confirm": "Are you sure you want to delete all entered values?",
    "kpitype-quantitative-tooltip": "Quantitative: numeric measurable values; requires an Unit of measure",
    "kpitype-qualitative-tooltip": "Qualitative: descriptive or categorical values; does not require Unit of measure",
    "unit-measure-hint": "Define the unit of measure for the KPI"
  },
  "measures": {
    "NONE": "None",
    "METER": "Meters",
    "KILOMETER": "Kilometers",
    "CENTIMETER": "Centimeters",
    "MILLIMETER": "Millimeters",
    "MICROMETER": "Micrometers",
    "NANOMETER": "Nanometers",
    "MILE": "Miles",
    "YARD": "Yards",
    "FOOT": "Feet",
    "INCH": "Inches",
    "KILOGRAM": "Kilograms",
    "GRAM": "Grams",
    "MILLIGRAM": "Milligrams",
    "MICROGRAM": "Micrograms",
    "TONNE": "Tonnes",
    "POUND": "Pounds",
    "OUNCE": "Ounces",
    "SECOND": "Seconds",
    "MILLISECOND": "Milliseconds",
    "MICROSECOND": "Microseconds",
    "NANOSECOND": "Nanoseconds",
    "MINUTE": "Minutes",
    "HOUR": "Hours",
    "DAY": "Days",
    "WEEK": "Weeks",
    "MONTH": "Months",
    "YEAR": "Years",
    "LITER": "Liters",
    "MILLILITER": "Milliliters",
    "CUBIC_METER": "Cubic Meters",
    "CUBIC_CENTIMETER": "Cubic Centimeters",
    "GALLON": "Gallons",
    "QUART": "Quarts",
    "PINT": "Pints",
    "CUP": "Cups",
    "FLUID_OUNCE": "Fluid Ounces",
    "SQUARE_METER": "Square Meters",
    "SQUARE_KILOMETER": "Square Kilometers",
    "SQUARE_CENTIMETER": "Square Centimeters",
    "SQUARE_MILLIMETER": "Square Millimeters",
    "HECTARE": "Hectares",
    "ACRE": "Acres",
    "METER_PER_SECOND": "Meters Per Second",
    "KILOMETER_PER_HOUR": "Kilometers Per Hour",
    "MILE_PER_HOUR": "Miles Per Hour",
    "CELSIUS": "Celsius",
    "FAHRENHEIT": "Fahrenheit",
    "KELVIN": "Kelvin",
    "JOULE": "Joules",
    "KILOJOULE": "Kilojoules",
    "CALORIE": "Calories",
    "KILOCALORIE": "Kilocalories",
    "WATT_HOUR": "Watt Hours",
    "KILOWATT_HOUR": "Kilowatt Hours",
    "PASCAL": "Pascals",
    "KILOPASCAL": "Kilopascals",
    "BAR": "Bars",
    "ATMOSPHERE": "Atmospheres",
    "TORR": "Torr",
    "KILOGRAM_PER_CUBIC_METER": "Kilograms Per Cubic Meter",
    "GRAM_PER_CUBIC_CENTIMETER": "Grams Per Cubic Centimeter",
    "HERTZ": "Hertz",
    "KILOHERTZ": "Kilohertz",
    "MEGAHERTZ": "Megahertz",
    "GIGAHERTZ": "Gigahertz"
  }
}
